var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoTableEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "j2c4uoz9ea"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.235294 0 0 0 0 0.364706 0 0 0 0 0.949020 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#j2c4uoz9ea)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#8C9299",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M6 19.286h12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.045 5.421 2.223 2.223a1 1 0 0 1 0 1.414l-6.922 6.921a2 2 0 0 1-.976.538l-2.583.58a1 1 0 0 1-1.194-1.195l.58-2.583a2 2 0 0 1 .537-.976L13.63 5.42a1 1 0 0 1 1.414 0z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "m11.308 7.745 3.03 3.03"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTableEdit);
export default __webpack_public_path__ + "static/media/ico-table-edit.cfac327ace527d722968eb72440e4c02.svg";
export { ForwardRef as ReactComponent };